
<template>

  <div>

    <h2>{{sharer.organisation.name}} - <b><small>{{sharer.telcoSiteId}}</small></b></h2>

    <el-tabs v-model="tabs">

      <el-tab-pane name="sharer-equipment" lazy>
        <span slot="label"><i class="fa fa-cogs"></i> Equiment</span>
        <equip-table :no-add="isTelco() || !isManager()"
          :site-id="sharer.site_id" :owner-id="sharer.organisation_id"
          :site-data="siteData"
           :showSearch="false" :title="(sharer.organisation.shortName ? sharer.organisation.shortName : sharer.organisation.name) + ' Equipment'" />
      </el-tab-pane>


      <el-tab-pane name="sharer-project" v-if="canAccess('finance|project')" lazy>
        <span slot="label"><i class="fa fa-cog"></i> Project</span>
        <project-tab :sharer="sharer" :site-data="siteData" :read-only="readOnly" />
      </el-tab-pane>



      <el-tab-pane name="sharer-utility" v-if="canAccess('finance|project')" lazy>
        <span slot="label"><i class="fa fa-plug"></i> {{utilLabel}} Supply</span>
        <utility-tab :sharer="sharer" :site-data="siteData" :read-only="readOnly" />
      </el-tab-pane>

      <el-tab-pane name="sharer-backhaul" v-if="canAccess('finance|project')" lazy>
        <span slot="label"><i class="fa fa-wifi"></i> Backhaul</span>
        <backhaul-tab :site-id= "sharer.site_id" :site-data="siteData" :sharer-id="sharer.organisation_id" :read-only="readOnly" />
      </el-tab-pane>

    </el-tabs>

    <el-row v-if="canAccess('finance|admin|management') && sharer.site_id && sharer.id">
      <el-col :span="24">
          <files-panel title="Sharer Docs" type="site" :id="sharer.site_id" process="sharer" :process-id="sharer.id" />
      </el-col>
    </el-row>

    <div v-if="sharer.updated_at">
      <hr />
      <span class="pull-right">Last update: <b>{{formatFriendlyDate(sharer.updated_at)}}</b><span v-if="sharer.updated_by"> by {{sharer.updated_by}}</span></span>
    </div>

  </div>

</template>

<script>

import {settings} from '@/components/Data'

import SiteMixins from '@/mixins/SiteMixins'

import EquipTable from '@/components/assets/EquipTable'

import ProjectTab from '@/components/sites/sharers/ProjectTab'
import UtilityTab from '@/components/sites/sharers/UtilityTab'
import BackhaulTab from '@/components/sites/sharers/BackhaulTab'

export default {

  mixins: [SiteMixins],

  components: {
    EquipTable,
    ProjectTab,
    UtilityTab,
    BackhaulTab
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },

    detailRowOptions: {
      type: Object
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },

  data () {    // TODO When saving, remember to do this- this.telco.outdoor = !this.telco.cabin
    return {
      sharer: this.rowData,
      siteData: this.rowData ? this.rowData.options : null,
      editMode: this.readOnly ? false : this.canAccess('finance') && this.isManager(),
      utilLabel: this.getUtilLabel(this.rowData),
      format: settings.selectDateFormat,
      items: [],
      sched: null,
      telcoName: this.rowData.organisation.name,
      telcoSiteId: this.rowData.telcoSiteId,
      tabs: 'sharer-equipment'
    }
  },

  mounted () {
//    console.log('Telco: siteData', this.siteData)
  }
}

</script>
